import { Button } from '@patternfly/react-core'
import { useState } from 'react'

export function useButtonActiveType() {
  const [activeType, setActiveType] = useState<'Total' | 'Por Categoria'>('Por Categoria')

  const ButtonsExibição = () => {
    return (
      <div className='pf-v5-u-p-sm'>
        <Button
          variant={activeType === 'Por Categoria' ? 'primary' : 'control'}
          onClick={() => setActiveType('Por Categoria')}
        >
          Por Categoria
        </Button>
        <Button
          variant={activeType === 'Total' ? 'primary' : 'control'}
          onClick={() => setActiveType('Total')}
        >
          Total
        </Button>
      </div>
    )
  }

  return { activeType, ButtonsExibição }
}
